import { IExcelImportTemplate, IJobsDownloadTemplate, ITemplateDTO } from 'wisestep-api';
import { IUserDTO } from 'wisestep-base';

export const getFavouredTemplatesFirst = (totalList: ITemplateDTO[], loggedInUser: IUserDTO) => {
  const favouredTemplates: ITemplateDTO[] = [];
  const unFavouredTemplates: ITemplateDTO[] = [];

  const sortedDesc = totalList
    .map((obj) => ({
      ...obj,
      date: new Date(obj.createdOn as string),
    }))
    .sort((objA, objB) => objB.date.getTime() - objA.date.getTime());

  sortedDesc.forEach((template) => {
    if (
      loggedInUser?.email &&
      template.favoredRecruitersByTemplate &&
      template?.favoredRecruitersByTemplate?.indexOf(loggedInUser?.email) > -1
    ) {
      favouredTemplates.push(template);
    } else {
      unFavouredTemplates.push(template);
    }
  });
  return [...favouredTemplates, ...unFavouredTemplates];
};

export const getFavouredExcelTemplatesFirst = (
  totalList: IExcelImportTemplate[],
  loggedInUser: IUserDTO
) => {
  const favouredTemplates: IExcelImportTemplate[] = [];
  const unFavouredTemplates: IExcelImportTemplate[] = [];

  const sortedDesc = totalList
    .map((obj) => ({
      ...obj,
      date: new Date(obj.createdOn as string),
    }))
    .sort((objA, objB) => objB.date.getTime() - objA.date.getTime());

  sortedDesc.forEach((template) => {
    if (loggedInUser?.email && template.isFavorite) {
      favouredTemplates.push(template);
    } else {
      unFavouredTemplates.push(template);
    }
  });
  return [...favouredTemplates, ...unFavouredTemplates];
};

export const getFavouredDownloadSettingsTemplatesFirst = (
  totalList: IJobsDownloadTemplate[],
  loggedInUser: IUserDTO
) => {
  const favouredTemplates: IJobsDownloadTemplate[] = [];
  const unFavouredTemplates: IJobsDownloadTemplate[] = [];

  const sortedDesc = totalList
    .map((obj) => ({
      ...obj,
      date: new Date(obj.createdOn as string),
    }))
    .sort((objA, objB) => objB.date.getTime() - objA.date.getTime());

  sortedDesc.forEach((template) => {
    if (loggedInUser?.email && template.isFavorite) {
      favouredTemplates.push(template);
    } else {
      unFavouredTemplates.push(template);
    }
  });
  return [...favouredTemplates, ...unFavouredTemplates];
};
